import apiClient from "./apiClient";

export function listNotifications(params = {}) {
  return apiClient.get("/notifications", { params });
}

export function markNotificationRead(id) {
  return apiClient.post(`/notifications/${id}/read`);
}
